export const isAwardType = (type, session) => type === session?.awardType;
